export default "__VITE_ASSET__DeFXWsa$__"